import React from 'react';
import { FiMail, FiArrowUpRight } from 'react-icons/fi';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { MdConnectWithoutContact } from 'react-icons/md';
import { useTranslate } from 'react-translate';

const socials = [
  {
    label: 'Email',
    value: 'raul@raulwebdev.com',
    href: 'mailto:raul@raulwebdev.com',
    icon: FiMail,
  },
  {
    label: 'LinkedIn',
    value: 'Raul Jimenez',
    href: 'https://www.linkedin.com/in/raul-jimenez-778b2a196/',
    icon: FaLinkedin,
  },
  {
    label: 'GitHub',
    value: 'jimenezraul',
    href: 'https://github.com/jimenezraul',
    icon: FaGithub,
  },
];

const Contact = () => {
  const t = useTranslate('Connect');
  const socialLabels = {
    Email: t('email'),
    LinkedIn: t('linkedin'),
    GitHub: t('github'),
  };

  return (
    <section id='contact' className='relative overflow-hidden py-8 md:py-12'>
      <div className='spotlight'></div>

      <div className='section-shell relative'>
        <div
          className='mx-auto flex max-w-2xl flex-col items-center text-center'
          data-aos='fade-up'
          data-aos-delay='50'
        >
          <div className='section-kicker'>
            <MdConnectWithoutContact />
            {t('title')}
          </div>
          <h2 className='section-title mt-6' data-aos='fade-up' data-aos-delay='100'>
            {t('headline')}
          </h2>
          <p className='section-copy mt-5 max-w-xl' data-aos='fade-up' data-aos-delay='150'>
            {t('subtitle')}
          </p>
        </div>

        <div
          className='mt-12 grid gap-5 sm:grid-cols-3'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          {socials.map(({ label, value, href, icon: Icon }) => (
            <a
              key={label}
              href={href}
              target={label === 'Email' ? undefined : '_blank'}
              rel={label === 'Email' ? undefined : 'noreferrer'}
              className='tile'
              aria-label={label}
            >
              <div className='icon-badge'>
                <Icon size={20} />
              </div>
              <div>
                <p className='tile-label'>{socialLabels[label]}</p>
                <p className='tile-value'>{value}</p>
              </div>
              <span className='tile-cta'>
                {t('cta')}
                <FiArrowUpRight />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
